import { render, staticRenderFns } from "./socialShare.vue?vue&type=template&id=ac676bc6"
import script from "./socialShare.vue?vue&type=script&lang=js"
export * from "./socialShare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports